import styled from 'styled-components'
import {
  clickDown,
  clickUp,
  trainAppear,
  trainRemove,
} from '../../../animations/Transitions'
import { cyberColors } from '../../../lib/colors'
import { Train_Styles_props } from './interface'

export const TrainWrapper = styled.div`
  margin-top: 15px;
  display: flex;
  /* justify-content: flex-end; */
  flex-direction: row-reverse;
  padding: 0px 18px;
  width: 100%;
  position: absolute;
  right: 50%;
  transform: translateX(50%);
`

export const TrapezoidWrapper = styled.div<Train_Styles_props>`
  display: flex;
  align-items: center;
  justify-content: center;
  transition: transform 0.167s linear;
  opacity: 1;
  :nth-child(2) {
    z-index: -1;
    ${({ anim }) => anim && trainRemove};
    position: relative;
  }
  :last-child {
    z-index: -1;
    opacity: 1;
    ${({ id }) => id < 5 && trainAppear};
  }
  .history {
    z-index: 4;
  }
`

export const TrapezoidElement = styled.div<Train_Styles_props>`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2px 8px;
  max-height: 14px;
  min-width: 36px;
  cursor: pointer;
  margin-right: 1px;
  ${clickUp}
  .gradient {
    position: absolute;
    user-select: none;
    pointer-events: none;
    height: 100%;
    width: 68px;
    background: linear-gradient(
      270.09deg,
      rgba(28, 28, 34, 0.77) 1.56%,
      rgba(32, 32, 39, 0) 93.33%
    );
    right: 60px;
    top: 0;
    z-index: 3;
  }
  &&.history {
    width: 64px;
    margin-right: 0px;
    z-index: 4;
    svg,
    p {
      z-index: 4;
    }
  }
  :active {
    ${clickDown}
  }
  svg {
    width: 100%;
    position: absolute;
    z-index: 0;
    transform: ${({ rotation }) =>
      rotation ? 'rotate(180deg)' : 'rotate(0deg)'};
  }
  p {
    color: ${cyberColors.whiteText};
    font-size: 10px;
    z-index: 1;
    transform: translateY(1px);
    text-transform: uppercase;
    white-space: nowrap;
  }
`
